function beforesubmitKontoMaske(){
    valid = true;

    if(valid && document.f.email.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_email);
        document.f.email.focus();
        valid = false;
    }

    if(valid && hx.isValidEmailAddress(document.f.email.value) == false){
        displayErrorBox(cpText.event_konto_form_email_exists);
        document.f.email.focus();
        valid = false;
    }

    if(valid && (typeof document.f.altespwd !== "undefined" && (document.f.pwd.value != '' || document.f.pwdw.value != ''))){

        if(valid && document.f.pwd.value == ''){
            displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_passwort);
            document.f.pwd.focus();
            valid = false;
        }

        if(valid && document.f.pwd.value.length < 6){
            displayErrorBox(cpText.event_konto_form_passwort_zu_kurz);
            document.f.pwd.focus();
            valid = false;
        }

        if(valid && document.f.pwdw.value == ''){
            displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_passwortw);
            document.f.pwdw.focus();
            valid = false;
        }

        if(valid && document.f.pwd.value != document.f.pwdw.value){
            displayErrorBox(cpText.event_konto_form_passwort_nicht_ident);
            document.f.pwdw.focus();
            valid = false;
        }

        if(valid && (document.f.altespwd.value == '#no_change#' || document.f.altespwd.value == '')){
            document.f.altespwd.value = "";
            document.f.altespwd.focus();
            displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_altes_pwd);
            valid = false;
        }
    }

    if(valid && document.f.anrede.options.selectedIndex == 0){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_anrede);
        document.f.anrede.focus();
        valid = false;
    }

    if(valid && document.f.vorname.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_vorname);
        document.f.vorname.focus();
        valid = false;
    }

    if(valid && document.f.nachname.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_nachname);
        document.f.nachname.focus();
        valid = false;
    }

    if(valid && document.f.adresse.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_adresse);
        document.f.adresse.focus();
        valid = false;
    }

    if(valid && document.f.plz.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_plz);
        document.f.plz.focus();
        valid = false;
    }

    if(valid && document.f.ort.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_ort);
        document.f.ort.focus();
        valid = false;
    }

    if(valid && document.f.id_shop_bundesland.options.selectedIndex == 0){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_bundesland);
        document.f.id_shop_bundesland.focus();
        valid = false;
    }

    if(valid && document.f.telefon.value == ''){
        displayErrorBox(cpText.event_konto_form_bitte_befuellen + " " + cpText.event_konto_form_telefon);
        document.f.telefon.focus();
        valid = false;
    }

    if(valid){
        $.ajax({
            url:ABSOLUTE_WEBPATH + 'cmshx_template/ajax/emailunique.php',
            data:$("form").serialize(),
            type:"POST",
            async: false,
        }).done(function(response){
            if(response == 'exists'){
                displayErrorBox(cpText.event_konto_form_email_exists);
                document.f.email.focus();
                valid = false;
            }
        });
        return valid;
    }else{
        return false;
    }
}

function beforesubmitMerkliste(){
    if(document.f.merkliste.value == ''){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.event_konto_merkliste);
        document.f.merkliste.focus();
        return false;
    }
    return true;
}

function askdel(id, url){
    displayConfirmBox(cpText.event_konto_askdel_merkliste, url + "?idmdel=" + id)
}

function beforesubmitPwdVergessen(){
    if(document.getElementById('email').value == '' || hx.isValidEmailAddress(document.getElementById('email').value) == false){
        displayErrorBox(cpText.shop_form_email_ungueltig);
        return false;
    }
    return true;
}

function beforesubmitLogin(){
    if(document.f.usr.value == '' || document.f.pwd.value == ''){
        displayErrorBox(cpText.shop_login_usr_pwd_befuellen);
        return false;
    }
    return true;
}